import axios from '@/plugins/axios';
import Axios from 'axios';
import updateObjectInArray from '@/utils/arrays/updateObjectInArray';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';
import { getUser } from '@/plugins/auth';

let fuenteBusquedaOrdenes = null;

export default {
	/**
	 * Gestor de OT: busqueda paginada en el servidor.
	 * Cancela la peticion anterior para que al teclear no lleguen respuestas
	 * viejas despues de las nuevas.
	 */
	async buscarOrdenes({ state, commit }, filtros = {}) {
		if (Object.keys(filtros).length) commit('setFiltroOrdenes', filtros);
		if (fuenteBusquedaOrdenes) fuenteBusquedaOrdenes.cancel('nueva busqueda');
		fuenteBusquedaOrdenes = Axios.CancelToken.source();
		commit('setLoadingOrdenes', true);
		commit('setErrorOrdenes', null);
		try {
			const { data } = await axios('/lodgings/busqueda-ot', {
				method: 'post',
				data: state.filtroOrdenes,
				cancelToken: fuenteBusquedaOrdenes.token,
			});
			commit('setOrdenes', data.ordenes);
			commit('setTotalOrdenes', data.total);
			commit('setTotalGeneralOrdenes', data.totalGeneral);
			commit('setKpisOrdenes', data.kpis);
			commit('setLoadingOrdenes', false);
			return data;
		} catch (error) {
			if (Axios.isCancel(error)) return null;
			commit('setLoadingOrdenes', false);
			commit('setErrorOrdenes', 'No se pudieron cargar las ordenes de trabajo');
			snackBarError(error)(commit);
			return null;
		}
	},
	/**
	 * Gestor de OT: trae TODAS las ordenes que cumplen el filtro actual (no solo
	 * la pagina visible) para exportarlas. Pagina de a 200 y corta en 2000 para
	 * no dejar el navegador colgado con una busqueda historica sin filtros.
	 */
	async obtenerOrdenesParaExportar({ state }, limite = 2000) {
		const porPagina = 200;
		const filas = [];
		let pagina = 1;
		let total = Infinity;
		while (filas.length < Math.min(total, limite)) {
			const { data } = await axios('/lodgings/busqueda-ot', {
				method: 'post',
				data: { ...state.filtroOrdenes, pagina, cantidad: porPagina },
			});
			total = data.total;
			filas.push(...data.ordenes);
			if (!data.ordenes.length || filas.length >= total) break;
			pagina += 1;
		}
		return { filas, total };
	},
	/**
	 * Gestor de OT: cantidad de ordenes por mes, para las pestanas del anio.
	 */
	async obtenerConteosOrdenes({ commit }, anio) {
		try {
			const { data } = await axios(`/lodgings/conteos-ot/${anio}`, { method: 'get' });
			commit('setConteosOrdenesPorMes', data.conteos);
			return data.conteos;
		} catch (error) {
			// los conteos son informativos: si fallan, las pestanas van sin numero
			return {};
		}
	},
	/**
	 * Create new lodging
	 * @param {Object} data to save
	 */
	async createLodging({ commit }, payload) {
		try {
			commit('setModeEdit', false);
			const { data } = await axios(`/lodging`, {
				method: 'post',
				data: payload,
			});
			commit('setLodgings', data.lodgings);
			commit('setLodgingWithProblems', null);
			snackBarSuccess('Guardado exitosamente')(commit);
			return data.newLodgings;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async createWorkerVisit({ commit }, payload) {
		try {
			commit('setModeEdit', false);
			await axios(`/lodging/visit`, {
				method: 'post',
				data: payload,
			});
			snackBarSuccess('Visita creada exitosamente')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deleteWorkerVisit({ commit }, payload) {
		try {
			const { data } = await axios(`/lodging/visit/${payload.index}/${payload.person}`, {
				method: 'delete',
			});
			snackBarSuccess('Visita eliminada exitosamente')(commit);
			commit('Person/setPersons', data.foundPerson, { root: true });
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	/**
	 * get all lodgings in place selected
	 */
	async fetchLodgings({ state, commit }, id) {
		try {
			commit('setLoadingLodgings');
			const { data } = await axios(`/lodgings/${id}/${state.month}`, { method: 'get' });
			commit('setModeEdit', false);
			commit('setcountLogingsPlace', data.lodgings.length);
			commit('setLodgings', data.lodgings);
		} catch (error) {
			commit('setLodgings', null);
			snackBarError(error)(commit);
		} finally {
			commit('setLoadingLodgings');
		}
	},
	/**
	 * get lodging by id
	 */
	async getLodging({ commit }, id) {
		try {
			const { data } = await axios(`/lodging/${id}`, { method: 'get' });
			commit('setLodgingSelect', data.lodging);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},

	async getLodgingsOfOnlyPerson({ commit }, ids) {
		try {
			const { data } = await axios(`/timeline/person/${ids}`, {
				method: 'get',
			});
			commit('setLodgingsOfPerson', data.lodgings);
			return data.lodgings;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getLodgingsOfPerson({ commit }, ids) {
		try {
			const { data } = await axios(`/timeline/person`, {
				method: 'post',
				data: { ids },
			});
			commit('setLodgingsOfPerson', data.lodgings);
			return data.lodgings;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	/**
	 * get all lodgings by admin
	 * @params {array} ids all ids place
	 */
	async getLodgingsOfAdmin({ state, commit }) {
		try {
			commit('User/setGlobalLoading', true, { root: true });
			const { data } = await axios(`/timeline/admin/${state.month}`, { method: 'get' });
			const places = data.places || [];
			commit('setLodgings', data.lodgings);
			commit('setPlaces', places);
			commit('Place/setPlaces', places, { root: true });
		} catch (error) {
			console.log(error);
			snackBarError(error)(commit);
		} finally {
			commit('User/setGlobalLoading', false, { root: true });
		}
	},
	/**
	 * Create new lodging
	 * @param {Object} data to save
	 */
	async updateLodging({ commit }, payload) {
		delete payload.lodging.calendar;
		try {
			const { data } = await axios(`/lodging/${payload.lodging._id}`, {
				method: 'put',
				data: payload,
			});
			commit('setLodgings', data.lodgings);
			commit('setLodgingSelect', data.lodging);
			snackBarSuccess('Actividad actualizada')(commit);
			return data.lodging;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	/**
	 * delete a lodging
	 */
	async deleteLodging({ state, commit, dispatch }, { id, currentRoute }) {
		try {
			const { data } = await axios(`/lodging/${id}`, {
				method: 'delete',
			});
			if (currentRoute == 'activities') dispatch('fetchLodgings', state.selectedPlace.value);
			else await dispatch('getLodgingsOfAdmin', state.month);
			snackBarSuccess(data.message)(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},

	/**
	 * get all places
	 */
	async fetchPlace({ state, commit }) {
		try {
			commit('setModeEdit', false);
			const { data } = await axios(`/place`, { method: 'get' });
			const placesWithLodgings = data.place.map(p => {
				const lodgings = state.lodgings.filter(l => l.place == p._id);
				return {
					...p,
					lodgings,
				};
			});
			commit('setPlaces', data.place);
			commit('Place/setPlaces', placesWithLodgings, { root: true });
			return data.place;
		} catch (error) {
			commit('setPlaces', null);
			snackBarError(error)(commit);
		}
	},
	async generatePdfReport(store, payload) {
		const { data } = await axios(
			`/lodgings/${payload.idPlace}/reports/month/${payload.date}/pdf`,
			{
				method: 'put',
				data: payload.activities,
				responseType: 'arraybuffer',
			}
		);
		return data;
	},
	async generateCsvReport(store, payload) {
		const { data } = await axios(
			`/lodgings/${payload.placeId}/reports/month/${payload.date}/csv`,
			{
				method: 'put',
				data: payload.activities,
				responseType: 'arraybuffer',
			}
		);
		return data;
	},
	async sendSmsConfirmation(
		{ state, commit, dispatch },
		{ lodgingId, type, handler, subtitle, currentRoute }
	) {
		try {
			const { data } = await axios(
				`/lodging/${lodgingId}/actions/sms-confirmation/${type}/${handler}`,
				{
					method: 'post',
					data: { subtitle },
				}
			);
			if (currentRoute == 'activities') commit('setLodgings', data.lodgings);
			else await dispatch('getLodgingsOfAdmin', state.month);
			snackBarSuccess('Solicitud enviada')(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async uploadDocument({ state, commit, dispatch }, { _id, filename, documents }) {
		try {
			const payload = new FormData();
			payload.append('_id', _id);
			payload.append('filename', filename);
			documents.forEach(document => {
				payload.append('documents', document);
			});
			const { data } = await axios(`/lodging/${_id}/upload`, {
				method: 'put',
				data: payload,
			});
			if (getUser().role == 'person')
				await dispatch('getLodgingsOfOnlyPerson', getUser().idPerson);
			else {
				commit('setLodgings', updateObjectInArray(state.lodgings, data.lodging));
				commit('setLodgingSelect', data.lodging);
			}

			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async createHistory({ commit, dispatch }, { lodgingId, history, idPerson }) {
		try {
			const { data } = await axios(`/lodging/${lodgingId}/history`, {
				method: 'post',
				data: history,
			});
			await dispatch('getLodgingsOfOnlyPerson', idPerson);
			snackBarSuccess(data.message)(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updateHistory({ commit, dispatch }, { lodgingId, history, idPerson }) {
		try {
			const { data } = await axios(`/lodging/${lodgingId}/history`, {
				method: 'put',
				data: history,
			});
			await dispatch('getLodgingsOfOnlyPerson', idPerson);
			snackBarSuccess(data.message)(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updateNotification({ commit }, { lodgingId, notiId, newState }) {
		try {
			await axios(`/lodging/${lodgingId}/notification/${notiId}`, {
				method: 'put',
				data: { state: newState },
			});
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updateNotes({ state, commit, dispatch }, { lodgingId, note, currentRoute }) {
		try {
			const { data } = await axios(`/lodging/${lodgingId}/notes`, {
				method: 'put',
				data: note,
			});
			if (getUser().role == 'person')
				await dispatch('getLodgingsOfOnlyPerson', getUser().idPerson);
			else {
				commit('setLodgingSelect', data.lodging);
				if (currentRoute == 'activities')
					dispatch('fetchLodgings', state.selectedPlace.value);
				else dispatch('getLodgingsOfAdmin', state.month);
			}
			snackBarSuccess('Nota agregada')(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async updateAllNotes({ state, commit, dispatch }, { lodgings, notes }) {
		try {
			await axios(`/lodging/allNotes`, {
				method: 'put',
				data: {
					lodgings,
					notes,
				},
			});
			dispatch('getLodgingsOfAdmin', state.month);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async deleteNotificationConfig({ commit, dispatch }, { placeId, notificationConfigId }) {
		try {
			const { data } = await axios(
				`/place/${placeId}/notification-config/${notificationConfigId}`,
				{
					method: 'delete',
				}
			);
			await dispatch('fetchPlace');
			snackBarSuccess(data.message);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async createNotificationConfig({ commit, dispatch }, { id, configData }) {
		try {
			const { data } = await axios(`/place/${id}/notification-config`, {
				method: 'post',
				data: configData,
			});
			await dispatch('fetchPlace');
			snackBarSuccess(data.message)(commit);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async createWorkOrder({ commit, dispatch }, { idLodging, payload }) {
		try {
			const { data } = await axios(`/lodging/${idLodging}/work-order`, {
				method: 'put',
				data: payload,
			});
			await dispatch('getLodgingsOfOnlyPerson', getUser().idPerson);
			snackBarSuccess(data.message)(commit);
			return data;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async getWorkOrder({ commit }, { idLodging, indexWorkOrder }) {
		try {
			const { data } = await axios(`/lodging/${idLodging}/work-order/${indexWorkOrder}`, {
				method: 'get',
			});
			let { workOrder, place, documents } = data;
			return { workOrder, place, documents };
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async atualizarOT({ commit }, payload) {
		try {
			const { data } = await axios('/lodging/editar/ot', {
				method: 'put',
				data: payload,
			});
			snackBarSuccess(data.message)(commit);
			return data.workOrder;
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async certifyWorkOrder({ commit }, { idLodging, payload }) {
		try {
			const { data } = await axios(`/lodging/${idLodging}/work-order/certify`, {
				method: 'post',
				data: payload,
			});
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};
